export default "__VITE_ASSET__8ec59e5e__"